import {css} from 'lit'; export default css`:host{flex-grow:1;height:100%}chameleon-nav-bar{height:var(--goto-layout-04)}chameleon-badge-counter{pointer-events:none}`;
    